import React from 'react'
import './Top.css'
import {
    // BrowserRouter,
    Link
  
  } from "react-router-dom";
function Top() {
    return (
   <>
            <div className="slider_area my-5">
                <div className="single_slider slider_bg_1 d-flex align-items-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5 col-md-6">
                                <div className="slider_text">
                                    {/* <h3>RCA IITKGP<br/><span>Khamma Ghanni</span></h3> */}
                                    <h3>RCA<br/><span>IITKGP</span></h3>
                                        {/* <p>Explore Rajasthan's culinary heritage at Khamma Ghanni - The Food Fest 2025, featuring the iconic Daal Baati and more!</p><br/> */}
                                        <p>Welcome to RCA! Join us to kickstart an amazing journey and to be part of our vibrant community!</p><br/>
                                            <div className="contact_btn align-items-center justify-content-center">
                                                <Link to="/About" className="boxed-btn4 shadow " style={{marginTop: '10px'}}>About</Link>
                                                <Link to="/FreshersRegistration" className="boxed-btn4 shadow " style={{marginTop: '10px'}}>Register Now</Link>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                        <div className="dog_thumb d-none d-lg-block" align="justify">
                            <img style={{display: 'block'}} src="img/rcaglow.png" alt="" width="500px"/>
                        </div>
                    </div>
                </div>
            </>
            )
}

            export default Top